//@flow
import axios from 'axios';
import { oauthHeaderJson } from '../helpers/oauth-header';
import { urlsConstants } from '../constants/url.constant';

export const defaultService = {
  findByFiltro,
  doGet,
  doDelete,
  doSave,
  listAll,
  doPost,
  doPut,
  getIdFromUrl,
  exportToExcel,
};

// defina um default sensato para operações longas (ex.: 3 min)
const DEFAULT_TIMEOUT = 180000; // 180sindex

// helper pra evitar repetir headers/timeout em todas as chamadas
function cfg(timeoutMs: number = DEFAULT_TIMEOUT) {
  return { headers: oauthHeaderJson(), timeout: timeoutMs };
}

export type Options = {
  pageSize: number,
  page: number,
  order: string,
  direction: string,
};

function getIdFromUrl(url) {
  const arrayUrl = url.split('/');
  return arrayUrl[arrayUrl.length - 1];
}

function exportToExcel(controller, filter, fields, labels) {
  const url = `${urlsConstants.URL_DOMAIN}/${controller}/export/CSV`;
  return axios.post(
    url,
    { pageSize: 100000, page: 0, filter, fields, labels },
    cfg()
  );
}

function findByFiltro(url: string, options: Options, filter: any) {
  return axios.post(
    url,
    {
      pageSize: options.pageSize,
      page: options.page - 1,
      order: options.order,
      direction: options.direction,
      filter,
    },
    cfg()
  );
}

function doGet(url: string) {
  return axios.get(url, cfg());
}

function doDelete(url: string) {
  return axios.delete(url, cfg());
}

// >>> aqui costumo dar um timeout MAIOR, pq salvar pode integrar no Omie
const SAVE_TIMEOUT = 300000; // 5 min (ajuste se precisar)

function doSave(url: string, entity: any) {
  if (entity.id === null || entity.id === undefined) {
    return axios.post(url, entity, cfg(SAVE_TIMEOUT));
  } else {
    return axios.put(url + entity.id, entity, cfg(SAVE_TIMEOUT));
  }
}

function listAll(url: string) {
  return axios.post(url, {}, cfg());
}

function doPost(url: string, entity: any) {
  return axios.post(url, entity, cfg());
}

function doPut(url: string, entity: any) {
  return axios.put(url, entity, cfg());
}
